import { render } from "./DocumentationView.vue?vue&type=template&id=1de68327&scoped=true&ts=true"
import script from "./DocumentationView.vue?vue&type=script&lang=ts"
export * from "./DocumentationView.vue?vue&type=script&lang=ts"

import "./DocumentationView.vue?vue&type=style&index=0&id=1de68327&scoped=true&lang=css"
import "./DocumentationView.vue?vue&type=style&index=1&id=1de68327&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de68327"]])

export default __exports__